import { render, staticRenderFns } from "./desk-order.vue?vue&type=template&id=541479b9&scoped=true&"
import script from "./desk-order.vue?vue&type=script&lang=js&"
export * from "./desk-order.vue?vue&type=script&lang=js&"
import style0 from "./desk-order.vue?vue&type=style&index=0&id=541479b9&lang=scss&scoped=true&"
import style1 from "./desk-order.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541479b9",
  null
  
)

export default component.exports